//创意状态
const adcreativeStatus = [
  {value: 'CREATIVE_STATUS_DELIVERY_OK',  label: '投放中'},
  {value: 'CREATIVE_STATUS_NOT_START',  label: '未到达投放时间'},
  {value: 'CREATIVE_STATUS_NO_SCHEDULE',  label: '不在投放时段'},
  {value: 'CREATIVE_STATUS_DISABLE',  label: '创意暂停'},
  {value: 'CREATIVE_STATUS_CAMPAIGN_DISABLE',  label: '已被广告组暂停'},
  {value: 'CREATIVE_STATUS_CAMPAIGN_EXCEED',  label: '广告组超出预算'},
  {value: 'CREATIVE_STATUS_AUDIT',  label: '新建审核中'},
  {value: 'CREATIVE_STATUS_REAUDIT',  label: '修改审核中'},
  {value: 'CREATIVE_STATUS_DELETE',  label: '已删除'},
  {value: 'CREATIVE_STATUS_DONE',  label: '已完成'},
  {value: 'CREATIVE_STATUS_AD_DISABLE',  label: '广告计划暂停'},
  {value: 'CREATIVE_STATUS_AUDIT_DENY',  label: '审核不通过'},
  {value: 'CREATIVE_STATUS_BALANCE_EXCEED',  label: '账户余额不足'},
  {value: 'CREATIVE_STATUS_BUDGET_EXCEED',  label: '超出预算'},
  {value: 'CREATIVE_STATUS_DATA_ERROR',  label: '数据错误'},
  {value: 'CREATIVE_STATUS_PRE_ONLINE',  label: '预上线'},
  {value: 'CREATIVE_STATUS_AD_AUDIT',  label: '广告计划新建审核中'},
  {value: 'CREATIVE_STATUS_AD_REAUDIT',  label: '广告计划修改审核中'},
  {value: 'CREATIVE_STATUS_AD_AUDIT_DENY',  label: '广告计划审核不通过'},
  {value: 'CREATIVE_STATUS_ALL',  label: '所有包含已删除'},
  {value: 'CREATIVE_STATUS_NOT_DELETE',  label: '所有不包含已删除'},
  {value: 'CREATIVE_STATUS_ADVERTISER_BUDGET_EXCEED',  label: '超出账户日预算'},
]

//素材类型
const materialType = [
  {label: '横版视频', value: 'CREATIVE_IMAGE_MODE_VIDEO'},
  {label: '竖版视频', value: 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'},
  {label: '大图横图', value: 'CREATIVE_IMAGE_MODE_LARGE'},
  {label: '大图竖图', value: 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'},
  {label: '小图', value: 'CREATIVE_IMAGE_MODE_SMALL'},
  {label: '组图', value: 'CREATIVE_IMAGE_MODE_GROUP'},
  {label: 'GIF图', value: 'CREATIVE_IMAGE_MODE_GIF'},
  {label: '开屏图片', value: 'CREATIVE_IMAGE_MODE_UNION_SPLASH'},
  {label: '开屏视频', value: 'CREATIVE_IMAGE_MODE_UNION_SPLASH_VIDEO'},
]

export default {
  adcreativeStatus,
  materialType
}